import { Directive, Input } from '@angular/core';

/* eslint-disable @angular-eslint/no-input-rename */
interface VirtualTableHeaderTemplateContext<TItem extends object> {
  $implicit: TItem[];
}

@Directive({
  selector: 'ng-template[libVirtualTableHeader]',
  standalone: false,
})
export class VirtualTableHeaderTemplateDirective<TItem extends object> {
  @Input('libVirtualTableHeader') data!: TItem[] | '';

  static ngTemplateContextGuard<TContextItem extends object>(
    dir: VirtualTableHeaderTemplateDirective<TContextItem>,
    ctx: unknown
  ): ctx is VirtualTableHeaderTemplateContext<TContextItem> {
    return true;
  }
}

interface VirtualTableRowTemplateContext<TItem extends object> {
  $implicit: TItem;
}

@Directive({
  selector: 'ng-template[libVirtualTableRow]',
  standalone: false,
})
export class VirtualTableRowTemplateDirective<TItem extends object> {
  @Input('libVirtualTableRow') data!: TItem[];

  static ngTemplateContextGuard<TContextItem extends object>(
    dir: VirtualTableRowTemplateDirective<TContextItem>,
    ctx: unknown
  ): ctx is VirtualTableRowTemplateContext<TContextItem> {
    return true;
  }
}
